export default function RiskMainController(
  $rootScope,
  $scope,
  loaderService,
  ssDialogService,

  userService,
  riskSharedModelService,
  riskDataService,
  bulkDeleteRisksDialog,
  syncRiskTypeDialog
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.handleExpandRiskClick = _handleExpandRiskClick;
  vm.hasData = false;
  vm.handleBulkDeleteClick = _handleBulkDeleteClick;
  vm.handleSyncClick = _handleSyncClick;

  _activate();

  function _activate() {
    _initPermissions();
    _initRiskSeverity();
    _initEventListner();
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initRiskSeverity() {
    if (vm.riskType) {
      vm.riskType = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskType);
      vm.riskType = riskSharedModelService.transformMeterStatusToRiskType(vm.riskType);
      vm.riskType = riskSharedModelService.addColorToProbability(vm.riskType);
    }
  }

  function _handleExpandRiskClick() {
    if (!vm.hasData) {
      riskDataService.getRiskType(vm.riskType.customerRiskTypeId).then((response) => {
        vm.riskType = angular.copy(response.data);
        vm.riskType = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskType);
        vm.riskType = riskSharedModelService.transformMeterStatusToRiskType(vm.riskType);
        vm.riskType = riskSharedModelService.addColorToProbability(vm.riskType);
        vm.hasData = true;
      });
    }
    vm.isExpanded = !vm.isExpanded;
  }

  function _initEventListner() {
    $scope.$on('refreshRiskType', (event, payload) => {
      if (payload.riskType.customerRiskTypeId === vm.riskType.customerRiskTypeId) {
        riskDataService.getRiskType(vm.riskType.customerRiskTypeId).then((response) => {
          Object.assign(vm.riskType, response.data);
          vm.riskType = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskType);
          vm.riskType = riskSharedModelService.transformMeterStatusToRiskType(vm.riskType);
          vm.riskType = riskSharedModelService.addColorToProbability(vm.riskType);
          vm.hasData = true;
          // eslint-disable-next-line no-empty
          if (vm.riskType.customerRisks && vm.riskType.customerRisks.length > 0) {
            angular.forEach(vm.riskType.customerRisks, (risk) => {
              if (risk) {
                riskSharedModelService.transformRiskTop(risk);
                riskSharedModelService.addSeverityDescriptionsToRiskType(risk);
                riskSharedModelService.transformMeterStatusToRiskType(risk);
              }
            });
          }
          if (payload.risk) {
            $rootScope.$broadcast('refreshRiskAfterSync', { risk: payload.risk });
          }
        });
      }
    });
  }

  function _handleBulkDeleteClick($event) {
    if (!vm.hasData) {
      loaderService.showViewLoader = true;
      riskDataService.getRiskType(vm.riskType.customerRiskTypeId)
        .then((response) => {
          vm.riskType = angular.copy(response.data);
          vm.riskType = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskType);
          vm.riskType = riskSharedModelService.transformMeterStatusToRiskType(vm.riskType);
          vm.riskType = riskSharedModelService.addColorToProbability(vm.riskType);
          vm.hasData = true;
          loaderService.showViewLoader = false;
          showBulkDeleteAssetsDialog($event);
        });
    } else {
      showBulkDeleteAssetsDialog($event);
    }
  }

  function showBulkDeleteAssetsDialog($event) {
    ssDialogService.dialogs.riskAdmin.bulkDeleteRisksDialog = ssDialogService.alert(
      bulkDeleteRisksDialog.getOptions($event, {
        riskType: vm.riskType,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.riskAdmin.bulkDeleteRisksDialog);
  }

  function _handleSyncClick($event) {
    if (!vm.hasData) {
      loaderService.showViewLoader = true;
      riskDataService.getRiskType(vm.riskType.customerRiskTypeId)
        .then((response) => {
          vm.riskType = angular.copy(response.data);
          vm.riskType = riskSharedModelService.addSeverityDescriptionsToRiskType(vm.riskType);
          vm.riskType = riskSharedModelService.transformMeterStatusToRiskType(vm.riskType);
          vm.riskType = riskSharedModelService.addColorToProbability(vm.riskType);
          vm.hasData = true;
          loaderService.showViewLoader = false;
          _showSyncRiskTypeDialog($event);
        });
    } else {
      _showSyncRiskTypeDialog($event);
    }
  }

  function _showSyncRiskTypeDialog($event) {
    loaderService.showViewLoader = true;
    ssDialogService.dialogs.riskAdmin.syncRiskTypeDialog = ssDialogService.alert(
      syncRiskTypeDialog.getOptions($event, {
        riskType: vm.riskType,
      })
    );
    loaderService.showViewLoader = false;
    ssDialogService.show(ssDialogService.dialogs.riskAdmin.syncRiskTypeDialog);
  }
}

RiskMainController.$inject = [
  '$rootScope',
  '$scope',
  'loaderService',
  'ssDialogService',

  'userService',
  'riskSharedModelService',
  'riskDataService',
  'bulkDeleteRisksDialog',
  'syncRiskTypeDialog',
];
